<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()" class="generic-form-fields">
  <dx-lookup 
    [createComponent]="addOption !== 'addTechnicalfeatureGroup' ? createTechnicalFeature : null"
    (valueChange)="onValueChange($event)"
    formField 
    required 
    formControlName="technicalFeature"
    [dataSource]="dataSource"
    displayExpr="name"
    valueExpr="id"
    [label]="(addOption === 'addTechnicalfeatureGroup' ?'menu.breadcrumb.technicalFeaturesGroups' :  'entity.technicalFeatureGroup.technicalFeature')| translate | ucfirst"
    [searchExpr]="['name']"
  /> 
</form>